wbApp.filter('leadStatus', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_LEAD_STATUS_OPEN');
            case 1:
                return $translate.instant('TXT_LEAD_STATUS_CONVERTED');
            case 2:
                return $translate.instant('TXT_LEAD_STATUS_CANNOT_CONTACT');
            case 3:
                return $translate.instant('TXT_LEAD_STATUS_NO_LONGER_INTERESTED');
            case 4:
                return $translate.instant('TXT_LEAD_STATUS_CANCELED');
            default:
                return '';
        }
    };
}]);